import React, { useState, useEffect } from "react";
import { Link } from "react-router";
import Spacer from "../../../components/Spacer";
import Banner from "../../../components/Banner";
import BannerInfo from "./components/BannerInfo";
import InfoServices from "./components/InfoServices";
import GeoservicesTable from "./components/GeoservicesTable";
import {
  getGcbaGeoservices,
  getExternalGeoservices,
  deleteGeoservice,
} from "../../../services/apiGeoservices";
import AuthCheck from "../../../utils/AuthCheck";
import APIError from "../../../models/ApiError";
import { useSearchContext } from "../../../context/SearchContext";

function GeoservicesPage() {
  const { handleApiError, handleApiResponse } = useSearchContext();
  const [gcbaGeoservices, setGcbaGeoservices] = useState([]);
  const [externalGeoservices, setExternalGeoservices] = useState([]);
  const [gcbaPage, setGcbaPage] = useState(1);
  const [externalPage, setExternalPage] = useState(1);
  const [gcbaTotalPages, setGcbaTotalPages] = useState(1);
  const [externalTotalPages, setExternalTotalPages] = useState(1);
  const [gcbaTotalItems, setGcbaTotalItems] = useState(0);
  const [externalTotalItems, setExternalTotalItems] = useState(0);
  const pageSize = 10;

  useEffect(() => {
    fetchGcbaGeoservices();
  }, [gcbaPage, pageSize]);

  useEffect(() => {
    fetchExternalGeoservices();
  }, [externalPage, pageSize]);

  const fetchGcbaGeoservices = async () => {
    try {
      const response = await getGcbaGeoservices({
        page: gcbaPage,
        page_size: pageSize,
      });
      setGcbaGeoservices(response.geoservices || []);
      const newTotalPages = response.total_pages || 1;
      setGcbaTotalPages(newTotalPages);
      setGcbaTotalItems(response.total_items || 0);
      if (gcbaPage > newTotalPages) {
        setGcbaPage(newTotalPages);
      }
    } catch (error) {
      if (error instanceof APIError) {
        handleApiError(error, true);
      } else {
      }
    }
  };

  const fetchExternalGeoservices = async () => {
    try {
      const response = await getExternalGeoservices({
        page: externalPage,
        page_size: pageSize,
      });
      setExternalGeoservices(response.geoservices || []);
      const newTotalPages = response.total_pages || 1;
      setExternalTotalPages(newTotalPages);
      setExternalTotalItems(response.total_items || 0);
      if (externalPage > newTotalPages) {
        setExternalPage(newTotalPages);
      }
    } catch (error) {
      if (error instanceof APIError) {
        handleApiError(error, true);
      } else {
      }
    }
  };

  const handleDelete = async (id, type) => {
    if (
      window.confirm("¿Estás seguro de que quieres eliminar este geoservicio?")
    ) {
      try {
        const response = await deleteGeoservice(id);
        handleApiResponse(response, true);
        if (type === "gcba") {
          fetchGcbaGeoservices();
        } else {
          fetchExternalGeoservices();
        }
      } catch (error) {
        if (error instanceof APIError) {
          handleApiError(error, true);
        } else {
        }
      }
    }
  };

  return (
    <>
      <Banner
        titleSection={"GEOSERVICIOS"}
        linkName={"Inicio"}
        nameSection={"Geoservicios"}
      />
      <Spacer />
      <BannerInfo />
      <Spacer />
      <InfoServices />
      <Spacer />
      <div className="container">
        <AuthCheck funcionalidadesRequeridas={["Crear Geoservicio"]}>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <div></div>
            <Link to="/crear-geoservicio" className="btn btn-primary">
              Crear Nuevo Geoservicio
            </Link>
          </div>
        </AuthCheck>
        <Spacer />
        <h4 className="bg-dark text-white p-3 rounded">Geoservicios GCBA</h4>

        <Spacer />
        <GeoservicesTable
          geoservices={gcbaGeoservices}
          onDelete={handleDelete}
          type="gcba"
          page={gcbaPage}
          totalPages={gcbaTotalPages}
          totalItems={gcbaTotalItems}
          onPageChange={setGcbaPage}
        />
        <Spacer />
        <h4 className="bg-dark text-white p-3 rounded">
          Geoservicios de Agentes Externos
        </h4>
        <Spacer />
        <GeoservicesTable
          geoservices={externalGeoservices}
          onDelete={handleDelete}
          type="external"
          page={externalPage}
          totalPages={externalTotalPages}
          totalItems={externalTotalItems}
          onPageChange={setExternalPage}
        />
      </div>
      <Spacer />
    </>
  );
}

export default GeoservicesPage;
